module.exports = __webpack_public_path__ + "img/fall-ga70efd1cc_640.e0a777d7.jpg";